export default "__VITE_ASSET__CzddhxaJ__"